import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { APPROVE_RADIO_VALUE } from "constants/FormatDataContanst";
import React from "react";
import Flatpickr from "react-flatpickr";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Col, FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { formatTaxCode } from "./utils";
export const formValidate = (errors, touched, field) => {
  if (field in errors) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (field in touched) {
      // return "is-valid";
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateObject = (errors, touched, fieldObject, field) => {
  //   console.log("errors", errors);
  //   console.log("touched", touched);
  //   console.log("field", field);
  if (errors[fieldObject] && errors[fieldObject][field]) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldObject in touched) {
      if (touched[fieldObject] && touched[fieldObject][field]) {
        // return "is-valid";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateFieldArray = (
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  type
) => {
  if (
    errors[fieldArray] &&
    errors[fieldArray][index] &&
    errors[fieldArray][index][fieldChild]
  ) {
    if (type === "date" || type === "select") {
      return "flat-pick-is-invalid";
    } else {
      return "is-invalid";
    }
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldArray in touched) {
      if (
        touched[fieldArray][index] &&
        touched[fieldArray][index][fieldChild]
      ) {
        // return "is-valid";";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

// Reack hook form useFieldArray
export const generateInputFieldArray = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  register,
  disabled,
  setInputValueChange,
  control,
  isThousandSeparator = false,
  allowNegative = false,
  isTaxCode = false
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => onBlurHandle(e, fieldArray, index, fieldChild),
          })}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              disabled={disabled}
              id={uniqueId}
              //   isAllowed={values => {
              //     const { floatValue } = values;
              //     return floatValue >= 5 && floatValue <= 10000;
              //   }}
              allowNegative={allowNegative}
              className={`form-control ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              value={value}
              onValueChange={v => {
                onChange(Number(v.value));
                setInputValueChange &&
                  setInputValueChange({ fieldArray, index, fieldChild });
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <Controller
            control={control}
            name={`${fieldArray}.${index}.${fieldChild}`}
            render={({ field: { onChange, name, value } }) => (
              <NumberFormat
                format="##########-###"
                style={{ width: "270px" }}
                id={uniqueId}
                allowEmptyFormatting={false}
                placeholder={
                  disabled ? "" : "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)"
                }
                mask="_"
                allowNegative={allowNegative}
                className={`form-control ${formValidateFieldArray(
                  errors,
                  touched,
                  fieldArray,
                  index,
                  fieldChild
                )}`}
                disabled={disabled}
                value={value}
                onValueChange={v => {
                  let finalValue = formatTaxCode(v.value);
                  onChange(finalValue);
                }}
              />
            )}
          />
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          //   placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => {
            //   onBlurHandle && onBlurHandle(e, fieldArray, index, fieldChild);
            // },
          })}
        />
      )}
      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="right"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

export const generateSelectFieldArray = (
  label,
  isRequire,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options,
  onChangeHandle,
  menuPlacementSetting = "auto"
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>  
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      <div
        id={uniqueId}
        className={`${formValidateFieldArray(
          errors,
          touched,
          fieldArray,
          index,
          fieldChild,
          "select"
        )}`}
      >
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field }) => (
            // @ts-ignore
            <Select
              {...field}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )}
        />
      </div>

      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="right"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

export const generateDateFieldArray = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
          {labelFrom}
          {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
          {labelTo && `- ${labelTo}`}
          {labelTo && isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      <div
        id={uniqueId}
        className={`${formValidateFieldArray(
          errors,
          touched,
          fieldArray,
          index,
          fieldChild,
          "date"
        )}`}
      >
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field }) => (
            <Flatpickr
              {...field}
              disabled={disabled}
              className={`form-control d-block Flatpickr__Input ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              placeholder={disabled ? "" : placeholder}
              options={options}
            />
          )}
        />
      </div>

      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="left"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

// Reack hook form
export const generateRadioGroupApprove = (
  listField,
  setValue,
  nameGroup,
  watch,
  register,
  isDisable = false,
  isHide = false,
  eventExpand
) => {
  return listField.map(item => {
    const listAnother = listField.filter(f => f.field !== item.field);
    let currentValue = watch(item.field);
    if (currentValue === "true") {
      currentValue = true;
    } else if (currentValue === "false") {
      currentValue = false;
    }
    return (
      !isHide &&
      !item.isDisable && (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            <Label
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-1"
            >
              <input
                {...register(item.field)}
                type="radio"
                name={nameGroup}
                disabled={isDisable || item.isDisable}
                checked={currentValue}
                value={currentValue}
                onClick={() => {
                  if (!currentValue) {
                    setValue(item.field, APPROVE_RADIO_VALUE.APPROVE);
                    for (const another of listAnother) {
                      setValue(another.field, APPROVE_RADIO_VALUE.NOT_APPROVE);
                    }
                  }
                  eventExpand && eventExpand();
                }}
                // id={item.field}
              ></input>
              {item.label}
            </Label>
          </FormGroup>
        </Col>
      )
    );
  });
};

export const generateCheckboxGroupApprove = (
  listField,
  register,
  isDisable = false,
  onClick,
  isHide = false
) => {
  return listField.map(item => {
    return (
      !isHide && (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            <Label
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-1"
            >
              <input
                {...register(item.field)}
                type="checkbox"
                disabled={isDisable}
                onClick={e => {
                  onClick && onClick(e);
                }}
                name={item.field}
                id={item.field}
              ></input>
              {item.label}
            </Label>
          </FormGroup>
        </Col>
      )
    );
  });
};

// Reack hook form
export const generateInputPasswordField = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  isPassword,
  showPasswordHandle
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldName}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>

      <React.Fragment>
        <div className="d-flex">
          <input
            disabled={disabled}
            type={isPassword ? "password" : "text"}
            className={`form-control ${formValidate(
              errors,
              touched,
              fieldName
            )}`}
            placeholder={disabled ? "" : placeholder}
            {...register(`${fieldName}`)}
          />
          <button
            style={{
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              marginLeft: "-1px",
            }}
            type="button"
            onClick={() => {
              showPasswordHandle && showPasswordHandle();
            }}
            className="btn btn-outline-info"
          >
            <i className="fas fa-eye"></i>
          </button>
        </div>
      </React.Fragment>
      {errors[fieldName] && (
        <MessageFormValidate error={errors[fieldName].message} />
      )}
    </React.Fragment>
  );
};

export const generateInputField = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  widthLabel,
  control,
  isThousandSeparator = false,
  isTaxCode = false,
  allowNegative = false,
  onChangeHandle,
  buttonLoadTaxInfo,
  toUpperCase = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldName} style={{ minWidth: widthLabel }}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidate(errors, touched, fieldName)}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldName}`)}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldName}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              allowNegative={allowNegative}
              disabled={disabled}
              value={value}
              onValueChange={v => {
                onChange(v.value);
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  format="##########-###"
                  style={{ width: "270px" }}
                  allowEmptyFormatting={false}
                  placeholder={disabled ? "" : placeholder}
                  mask="_"
                  allowNegative={allowNegative}
                  className={`form-control ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    let finalValue = formatTaxCode(v.value);
                    onChange(finalValue);
                    onChangeHandle && onChangeHandle(finalValue, fieldName);
                  }}
                />
              )}
            />
            {buttonLoadTaxInfo && buttonLoadTaxInfo()}
          </div>
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidate(errors, touched, fieldName)}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldName}`)}
          onInput={e => {
            if (toUpperCase) {
              e.target.value = ("" + e.target.value).toUpperCase();
            }
          }}
        />
      )}
      {errors[fieldName] && (
        <MessageFormValidate error={errors[fieldName].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectField = (
  label,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto",
  onChangeHandle,
  allowCreate = false,
  isLoading = false,
  isClearable = false,
  isMulti = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) =>
          !allowCreate ? ( // @ts-ignore
            <Select
              {...field}
              isMulti={isMulti}
              isLoading={isLoading}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle();
              }}
              isOptionSelected={
                isMulti
                  ? undefined
                  : (option, selectValue) => selectValue.some(i => i === option)
              }
              isClearable={isClearable}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : (
            <CreatableSelect
              {...field}
              isClearable={isClearable}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle();
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )
        }
      />

      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

export const generateDateField = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={placeholder}
            options={options}
          />
        )}
      />
      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

// Reack hook form object
export const generateInputFieldObject = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldObject,
  field,
  placeholder,
  register,
  disabled,
  control,
  isTaxCode = false,
  isThousandSeparator = false,
  allowNegative = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldObject}.${field}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              className={`form-control ${formValidateObject(
                errors,
                touched,
                fieldObject,
                field
              )}`}
              allowNegative={allowNegative}
              disabled={disabled}
              value={value}
              onValueChange={v => {
                onChange(v.value);
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            <Controller
              control={control}
              name={`${fieldObject}.${field}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  format="##########-###"
                  style={{ width: "270px" }}
                  allowEmptyFormatting={allowNegative}
                  placeholder={disabled ? "" : placeholder}
                  mask="_"
                  allowNegative={allowNegative}
                  className={`form-control ${formValidateObject(
                    errors,
                    touched,
                    fieldObject,
                    field
                  )}`}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    let finalValue = formatTaxCode(v.value);
                    onChange(finalValue);
                  }}
                />
              )}
            />
          </div>
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      )}
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectFieldObject = (
  label,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto"
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Select
            {...field}
            menuPlacement={menuPlacementSetting}
            isDisabled={disabled}
            placeholder={placeholder}
            options={options}
            classNamePrefix="select2-selection"
          />
        )}
      />

      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateDateFieldObject = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};
